import { useEffect } from 'react';

const PRECONNECT_HREF = 'https://fonts.gstatic.com';
const MARKER = 'data-landing-page-webfont';

function ensureLink(href: string, rel: string, crossOrigin?: string): void {
  if (document.head.querySelector(`link[${MARKER}][href="${href}"]`)) return;

  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  link.setAttribute(MARKER, '');
  document.head.appendChild(link);
}

/** Appended once per document and never removed: removing would flash fallback fonts on every remount. */
export const useWebfonts = (href: string | undefined, enabled: boolean): void => {
  useEffect(() => {
    if (!enabled || !href || typeof document === 'undefined') return;

    ensureLink(PRECONNECT_HREF, 'preconnect', 'anonymous');
    ensureLink(href, 'stylesheet');
  }, [href, enabled]);
};
